import { columns, drawerFilters, toolbarActions } from './helpers'
import { useMemo, useState } from 'react'
import { toTableRowItems } from './serializers'
import sModal from 'components/core-ui/Modal/Modal.modules.scss'
import s from '../../../commonStyles.modules.scss'
import { useNotification } from 'hooks'
import { makeCoreGetFileRequest, makeCoreGetRequest } from 'utils/api'
import { toTableGETUrl } from 'components/core-ui/Table/serializers'
import { formatErrorMessage } from 'utils/formatting'
import { Table } from 'components/core-ui/Table'
import { useQuery } from 'react-query'
import { Modal } from 'components/core-ui/Modal'
import { Grid } from '@mui/material'
import { Button } from '@fullscreendigital/carrefour-dex-fe'
import { formatAndDownloadResponse } from 'utils/helpers'
import { getDepositNameOptions, getShopOptions } from '../../api'

const UnorderedProducts = ({ isHistorical }) => {
  const { showNotification } = useNotification()

  const [tableItems, setTableItems] = useState<UnorderedProducts[]>([])
  const [totalCount, setTotalCount] = useState<number>(0)
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [selectedRow, setSelectedRow] = useState<UnorderedProducts>()
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [shouldRefreshData, setShouldRefreshData] = useState<boolean>(false)
  const [isExcelExportLoading, setIsExcelExportLoading] = useState<boolean>(false)

  const closeModal = () => setIsOpen(false)

  const fetchData = async ({ page, rowsPerPage, order, orderBy, tableFilters }) => {
    setIsLoading(true)
    try {
      const response = await makeCoreGetRequest(
        toTableGETUrl({
          url: isHistorical
            ? '/shop-reception/unexpectedReceptionProductArchive'
            : '/shop-reception/unexpectedReceptionProduct',
          tableFilters,
          page,
          rowsPerPage,
          order,
          orderBy
        })
      )

      setTableItems(toTableRowItems(response.unexpectedReceptionList))
      setTotalCount(response.page.totalCount)
      setIsLoading(false)
    } catch (error) {
      showNotification({
        message: `A aparut o eroare la obtinerea datelor. ${formatErrorMessage(error)}`,
        type: 'error'
      })
    }
  }

  const markAsResolved = id => {
    setSelectedRow(id)
    setIsOpen(true)
  }

  const { isLoading: isResolveProductLoading, refetch: resolveProduct } = useQuery(
    ['resolve-product'],
    async id => {
      await makeCoreGetRequest(
        isHistorical
          ? `/shop-reception/unexpectedReceptionProductArchive/${selectedRow.id}`
          : `/shop-reception/unexpectedReceptionProduct/${selectedRow.id}`
      )
      setShouldRefreshData(true)
      closeModal()

      return
    },
    {
      onError: error => {
        showNotification({
          message: `A apărut o eroare la rezolvarea produsului. ${formatErrorMessage(error)}`,
          type: 'error'
        })
      },
      enabled: false
    }
  )

  const exportFileExcel = async (tableState, e) => {
    setIsExcelExportLoading(true)
    const { filters, order, orderBy } = tableState
    const url = toTableGETUrl({
      url: isHistorical
        ? '/shop-reception/unexpectedReceptionProductArchive/export'
        : '/shop-reception/unexpectedReceptionProduct/export',
      tableFilters: filters,
      order,
      orderBy
    })

    try {
      const response = await makeCoreGetFileRequest(url, {
        responseType: 'blob'
      })
      formatAndDownloadResponse(response);
      setIsExcelExportLoading(false)
    } catch (error) {
      setIsExcelExportLoading(false)
      showNotification({
        message: `A aparut o eroare la descarcarea fisierului. ${formatErrorMessage(error)}`,
        type: 'error'
      })
    }
  }

  const toolbar = useMemo(() => toolbarActions({
      totalCount,
      exportFileExcel: exportFileExcel,
      isExcelExportLoading }),
    [totalCount, isExcelExportLoading])

  const { data: depositOptions } = getDepositNameOptions(showNotification)
  const { data: shopOptions } = getShopOptions(showNotification)

  return (
    <div className={s.mainContainer}>
      <Modal
        isModalOpen={isOpen}
        closeModal={closeModal}
        modalTitle={`Doriti rezolvarea pentru produsul ${selectedRow?.productName}?`}
        modalWidth="50%"
      >
        <Grid xs={12} item className={sModal.modalButtons}>
          <Button variant="outlined" label="Nu" onClick={() => closeModal()} />
          <Button variant="contained" label={'Da'} onClick={() => resolveProduct()} />
        </Grid>
      </Modal>
      <Table
        hideCheckbox
        orderBy="id"
        order="desc"
        columns={columns(markAsResolved)}
        items={tableItems}
        fetchData={fetchData}
        isLoading={isLoading}
        totalCount={totalCount}
        shouldRefreshData={shouldRefreshData}
        setShouldRefreshData={setShouldRefreshData}
        rowActions={[]}
        rowActionsWidth="130px"
        toolbarActions={toolbar}
        filters={drawerFilters(shopOptions, depositOptions)}
        filtersLabel="Filtreaza"
        filtersButtonLabel="Filtreaza"
        appliedFiltersLabel="Filtre"
        cancelFiltersButtonLabel="Anuleaza"
        applyFiltersButtonLabel="Aplica"
        rowsPerPage={10}
        rowsPerPageOptions={[10, 25, 50]}
      />
    </div>
  )
}

export default UnorderedProducts
